var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitterMail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0317 25.0008C21.0694 25.0008 24.3718 19.9986 24.3718 15.6607C24.3718 15.5186 24.3718 15.3772 24.3622 15.2364C25.0047 14.7717 25.5593 14.1963 26 13.5372C25.4009 13.8026 24.7653 13.9767 24.1146 14.0536C24.7998 13.6434 25.3127 12.9981 25.5578 12.238C24.9134 12.6203 24.2084 12.8898 23.4733 13.0348C22.9783 12.5085 22.3238 12.16 21.6108 12.0432C20.8978 11.9264 20.1663 12.0479 19.5293 12.3888C18.8923 12.7297 18.3855 13.271 18.0872 13.929C17.7888 14.587 17.7157 15.3249 17.879 16.0287C16.5739 15.9632 15.2971 15.6241 14.1316 15.0332C12.9661 14.4423 11.9378 13.613 11.1136 12.5989C10.6938 13.3216 10.5652 14.1771 10.7541 14.9912C10.9429 15.8053 11.4349 16.5169 12.1299 16.981C11.6075 16.9655 11.0965 16.8246 10.64 16.5701C10.64 16.5836 10.64 16.5976 10.64 16.6117C10.6402 17.3696 10.9026 18.1041 11.3826 18.6906C11.8626 19.2771 12.5307 19.6796 13.2736 19.8296C12.7903 19.9614 12.2833 19.9807 11.7914 19.886C12.0011 20.5382 12.4095 21.1086 12.9594 21.5174C13.5093 21.9261 14.1732 22.1528 14.8582 22.1656C13.6958 23.0792 12.2599 23.5751 10.7814 23.5736C10.5203 23.5731 10.2593 23.5573 10 23.5263C11.5012 24.4896 13.2479 25.0006 15.0317 24.9983",
    fill: "#959EA8"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterMail);
export default __webpack_public_path__ + "static/media/twitter_mail.48dc06731ab5696a627d25e3c931ae48.svg";
export { ForwardRef as ReactComponent };